import { render, staticRenderFns } from "./ProjectTypeTable.vue?vue&type=template&id=b04d4488&"
import script from "./ProjectTypeTable.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports